import React from "react";
import {useLocation, Route, Routes, Navigate} from "react-router-dom";
// reactstrap components
import {Container, Row, Col} from "reactstrap";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

import routes from "routes.js";
import IndexNavbar from "../../components/Navbars/IndexNavbar";
import axios from "axios";
import {getCookie} from "tools/tools"
import InfoModal from "../../components/Modals/InfoModal";
import Ract from "react";
import {Loader} from "@skbkontur/react-ui";
import {useTranslation} from "react-i18next";
import Footer from "../../components/Footers/IndexFooter";

class FabricProperties {

    constructor(thermal_conductivity, heat_capacity, density, initial_temperature) {
        this.thermal_conductivity = thermal_conductivity; //теплопроводность k   Вт/(м*К)
        this.heat_capacity = heat_capacity; //c Дж/(кг*К)
        this.density = density;// p кг/м^3
        this.initial_temperature = initial_temperature; //T0
    }
}

const defaultValues = {
    Ta: '5 + 10*sin(0.0001*t)',
    h: 6,
    diagnosticPoint: {
        x: 0, y: 0, z: 0
    },
    WM: new FabricProperties(0.503, 3600, 1050, 37.2),
    GM: new FabricProperties(0.515, 3680, 1050, 37.0),
    csf: new FabricProperties(0.572, 3930, 1007, 35.5),
    scalp: new FabricProperties(0.37, 3200, 1000, 31),
    eye: new FabricProperties(0.594, 4200, 1000, 34),
    compact_bone: new FabricProperties(0.400, 1300, 1500, 34),
    spinal_bone: new FabricProperties(0.400, 1500, 1500, 34),
    blood: new FabricProperties(0.482, 3840, 1050, 37),
    muscles: new FabricProperties(0.500, 3430, 1090, 37),
};

const FABRICS = ['WM', 'GM', 'csf', 'scalp', 'eye', 'compact_bone', 'spinal_bone', 'blood', 'muscles'];
const FABRICS_PARAMS = ['r', 'C', 'p', 'k', 'T0'];


const HardFemCalc = (props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [isSend, setIsSend] = React.useState(false);
    const [modalIsOpen, setModalIsOpen] = Ract.useState(false);
    const [calcErrors, setCalcErrors] = Ract.useState({});
    const {t, i18n} = useTranslation();
    const [values, setValues] = React.useState({
        Ta: defaultValues.Ta,
        h: defaultValues.h,
        diagnosticPoint: {...defaultValues.diagnosticPoint},
        mesh: null,
        fabrics: {
            WM: {...defaultValues.WM},
            GM: {...defaultValues.GM},
            csf: {...defaultValues.csf},
            scalp: {...defaultValues.scalp},
            eye: {...defaultValues.eye},
            compact_bone: {...defaultValues.compact_bone},
            spinal_bone: {...defaultValues.spinal_bone},
            blood: {...defaultValues.blood},
            muscles: {...defaultValues.muscles},
        }
    });

    React.useEffect(() => {
        document.body.classList.add("bg-white");
        return () => {
            document.body.classList.remove("bg-default");
        };
    }, []);


    const handleChange = (e) => {
        const {name, value, files} = e.target;

        if (name === 'mesh' && files.length > 0) {
            setValues((prevState) => ({
                ...prevState, mesh: files[0]
            }));
            setCalcErrors((prevErrors) => ({...prevErrors, ['mesh_file']: null}));
        } else if (name === 'Ta' || name === 'h') {
            setValues((prevState) => ({
                ...prevState, [name]: value
            }));
            setCalcErrors((prevErrors) => ({...prevErrors, [name]: null}));
        } else if (['x', 'y', 'z'].includes(name)) {
            setValues((prevState) => ({
                ...prevState, diagnosticPoint: {
                    ...prevState.diagnosticPoint, [name]: value
                }
            }));
            setCalcErrors((prevErrors) => ({
                ...prevErrors,
                diagnosticPoint: {
                    ...prevErrors?.diagnosticPoint,
                    [name]: null
                }
            }));
        } else {
            const [fabric, param] = name.split('$');
            setValues((prevState) => ({
                ...prevState, fabrics: {
                    ...prevState.fabrics, [fabric]: {
                        ...prevState.fabrics[fabric], [param]: value
                    }
                }
            }));
            setCalcErrors((prevErrors) => ({
                ...prevErrors,
                fabrics: {
                    ...prevErrors?.fabrics,
                    [fabric]: {
                        ...prevErrors?.fabrics?.[fabric],
                        [param]: null
                    }
                }
            }));
        }
    };

    const handleSubmit = () => {
        // todo дополнительная валидация

        const formData = new FormData();
        setIsLoading(true);
        formData.append("mesh_file", values.mesh);

        const payload = {
            Ta: values.Ta,
            h: values.h,
            diagnosticPoint: values.diagnosticPoint,
            fabrics: values.fabrics,
        };
        formData.append("data", JSON.stringify(payload));
        console.log(formData);
        axios.post('/api/hard-fem-calc', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRFToken': getCookie('csrftoken'),
            },
            withCredentials: true,
        })
            .then((response) => {
                console.log("Response from server:", response.data);
                //alert("Data submitted successfully!");
                setIsSend(true);
            })
            .catch((error) => {
                console.log(error.response?.data)
                //console.error("Error from server:", error.response?.data || error.message);
                setCalcErrors(error.response?.data)
                setModalIsOpen(true)
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const renderError = (error) => {
        if (!error) return null;
        return <small className="text-danger">{error}</small>;
    };

    const errorModalBody = () => {
        return calcErrors == null || calcErrors.length === 0 ? ('Calculation started') : (<ul>
            {calcErrors['error'] ? calcErrors['error'] : "check the form carefully"}
            {/*{calcErrors.map((error, index) => (*/}
            {/*    <li key={index}>*/}
            {/*        <a target="_blank" rel="noopener noreferrer">*/}
            {/*            {error}*/}
            {/*        </a>*/}

            {/*    </li>*/}
            {/*))}*/}
        </ul>)
    }

    return (
        <div className="content">
            <IndexNavbar
                {...props}
                brandText={"test"}
            ></IndexNavbar>

            <InfoModal
                isOpen={modalIsOpen}
                modalTitle={'Errors occurred during validating data'}
                onRequestClose={() => setModalIsOpen(false)}
                body={errorModalBody}
                contentLabel="Error modal">
            </InfoModal>
            <div className="section section-components" style={{paddingTop: 40}}>
                <div className="container mb-5 pb-100">
                    <Loader active={isLoading} type="big">
                        <h3 className="h1 text-success font-weight-bold mb-4">Hard FEM</h3>
                        <small className="mb-3 text-uppercase font-weight-bold">{t('inputDataParameters')}</small>

                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">{t('diagnosticPoint')}:</label>
                            <div className="col-sm-8">
                                {['x', 'y', 'z'].map((coord) => (
                                    <div className="form-group row" key={coord}>
                                        <label htmlFor={coord}
                                               className="col-sm-6 col-form-label">{coord.toUpperCase()} coord
                                            (mm)</label>
                                        <div className="col-sm-6">
                                            <input
                                                id={coord}
                                                name={coord}
                                                type="number"
                                                defaultValue={values.diagnosticPoint[coord]}
                                                step="0.0000001"
                                                className=" form-control"
                                                onChange={handleChange}
                                            />
                                            {renderError(calcErrors['diagnosticPoint']?.[coord])}
                                        </div>

                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="h" className="col-sm-8 col-form-label">{t('HeatTransferCoefficient')}</label>
                            <div className="col-sm-4">
                                <input id="h" name="h" type="number" defaultValue={defaultValues.h} step="0.0000001"
                                       className="form-control" onChange={handleChange}/>
                                {renderError(calcErrors['h'])}
                            </div>

                        </div>

                        <div className="form-group row">
                            <label htmlFor="Ta" className="col-sm-8 col-form-label">{t('AmbientTemperatureF')}</label>
                            <div className="col-sm-4">
                                <input id="Ta" name="Ta" type="text" defaultValue={defaultValues.Ta}
                                       className="form-control" onChange={handleChange}/>
                                {renderError(calcErrors['Ta'])}
                            </div>

                        </div>

                        <div className="form-group row">
                            <label htmlFor="mesh" className="col-sm-8 col-form-label">{t('MeshFile')}</label>
                            <div className="col-sm-4">
                                <input id="mesh" name="mesh" type="file" className="form-control"
                                       onChange={handleChange}/>
                                {renderError(calcErrors['mesh_file'])}
                            </div>
                        </div>

                        <hr/>
                        <small className="mb-3 text-uppercase font-weight-bold">{t('PropertiesOfFabrics')}</small>

                        {FABRICS.map((fabric) => (
                            <React.Fragment key={fabric}>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label">{t(fabric)}</label>
                                    <div className="col-sm-8">
                                        {Object.keys(defaultValues[fabric]).map((param) => (
                                            <div className="form-group row" key={`${fabric}.${param}`}>
                                                <label htmlFor={`${fabric}$${param}`}
                                                       className="col-sm-7 col-form-label">
                                                    {t(param)}
                                                </label>
                                                <div className="col-sm-5">
                                                    <input
                                                        id={`${fabric}$${param}`}
                                                        name={`${fabric}$${param}`}
                                                        type="number"
                                                        defaultValue={values.fabrics[fabric][param]}
                                                        step="0.0000001"
                                                        className="form-control"
                                                        onChange={handleChange}
                                                    />
                                                    {renderError(calcErrors['fabrics']?.[fabric]?.[param])}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                        <button id="button_1" className="btn btn-secondary mb-2"
                                onClick={handleSubmit}>{t('Calc')}
                        </button>
                        <br/>
                        {isSend && (
                            <Container>
                                <div className="alert alert-success" role="alert">
                                    {t('CalculationCompleted')}
                                </div>
                            </Container>
                        )}
                        <div id="result"></div>
                    </Loader>
                </div>
            </div>
            <Container style={{backgroundColor: '#f4f5f7'}} fluid>
                <Footer/>
            </Container>
        </div>

    );
};

export default HardFemCalc;
